import { PageSectionType } from '../../enums/page-section-type';
import globals from '@/utils/globals';

interface IContentSwitcherSwitch {
	id: string;
	from: string;
	to: string;
}

export class ContentSwitcherPlugin {
	public initiate(): void {
		this.subscribeToContentSwitcherChangeEvent();
	}

	private subscribeToContentSwitcherChangeEvent(): void {
		document.addEventListener('contentChanged', (event: any) => {
			const eventDetails: IContentSwitcherSwitch | null = this.getEventDetails(event.detail);

			if (eventDetails === null || eventDetails.from === null) return;

			globals.accountPageTracker.trackContentSwitch(
				eventDetails.id as PageSectionType,
				eventDetails.from,
				eventDetails.to,
			);
		});
	}

	private getEventDetails(eventDetails: any): IContentSwitcherSwitch | null {
		if (typeof eventDetails === 'undefined') return null;

		if ('from' in eventDetails && 'to' in eventDetails && 'id' in eventDetails) {
			return {
				id: eventDetails.id,
				from: eventDetails.from,
				to: eventDetails.to,
			};
		}

		return null;
	}
}
